import { analytics } from './analytics';
import type { LiveChatLink } from '../utils/liveChatLink';

/**
 * CORE-1253 — человек нажал уведомление о сообщении в чате практики.
 *
 * Средняя ступень воронки: бэкенд пишет `live_chat_notification_delivered`,
 * экран — `live_chat_deeplink_opened`, когда чат действительно открылся. Без
 * этой ступени «не дошли до чата» не отличить от «не нажали»: провал между
 * нажатием и экраном — это маршрутизация, провал до нажатия — само уведомление.
 */
export function trackLiveChatNotificationOpened(
  source: 'push' | 'inbox',
  link: LiveChatLink,
  notificationType?: string | null,
): void {
  analytics.track('live_chat_notification_opened', {
    event_id: link.id,
    surface: link.chat === 'live' ? 'live-chat' : 'event-thread',
    source,
    notification_type: notificationType ?? null,
  });
}
